document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".myFeaturedSwiper", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      640: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    },
  });

// Index Slider
  new Swiper('.index_banner_slide', {
      loop: true,
      // nextButton: '.swiper-button-next',
      // prevButton: '.swiper-button-prev',
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
       speed: 1000, 
  });

    //review slider
      new Swiper('.reviews-swiper', {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      autoplay: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  

    //Showroom Tab

    const buttons = document.querySelectorAll('.tab-button');
  const contents = document.querySelectorAll('.tab-content');

  // Check each tab for content
  contents.forEach(content => {
    const inner = content.querySelector('.tab-inner');
    const comingSoon = content.querySelector('.coming-soon');

    const hasImage = content.querySelector(".tab-images img") !== null;
    const hasHeading = content.querySelector(".tab-text h2") !== null;
    const hasParagraph = content.querySelector(".tab-text p, .tab-text div, .tab-text span") !== null;

    if (!hasImage && !hasHeading && !hasParagraph) {
      if (inner) inner.style.display = "none";
      if (comingSoon) comingSoon.style.display = "block";
    } else {
      if (inner) inner.style.display = "flex";
      if (comingSoon) comingSoon.style.display = "none";
    }
  });

  // Show first tab
  contents.forEach(content => {
    content.style.display = content.classList.contains('active') ? 'block' : 'none';
  });

  // Tab click
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');

      // Active button
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Show corresponding content
      contents.forEach(content => {
        if (content.id === tab) {
          content.classList.add('active');
          content.style.display = 'block';
        } else {
          content.classList.remove('active');
          content.style.display = 'none';
        }
      });
    });
  });


//     const buttons = document.querySelectorAll('.tab-button');
//     const contents = document.querySelectorAll('.tab-content');

//     // Initialize: show first tab, hide others
//     contents.forEach(content => {
//       if (content.classList.contains('active')) {
//         content.style.display = 'block';
//       } else {
//         content.style.display = 'none';
//       }
//     });

//     buttons.forEach(button => {
//       button.addEventListener('click', () => {
//         const tab = button.getAttribute('data-tab');

//         // Update active class on buttons
//         buttons.forEach(btn => btn.classList.remove('active'));
//         button.classList.add('active');

//         // Show/hide tab content
//         contents.forEach(content => {
//           if (content.id === tab) {
//             content.classList.add('active');
//             content.style.display = 'block';
//           } else {
//             content.classList.remove('active');
//             content.style.display = 'none';
//           }
//         });
//       });
//     });


 });


// Add 'body-overlay' class on the body tag hovering on .header__inline-menu li
const menu = document.querySelector('.header__inline-menu');
if (menu) {
  menu.addEventListener('mouseover', e => {
    const li = e.target.closest('li.gm-has-submenu');
    if (!li) return;
    document.body.classList.add('body-overlay');
  });

  menu.addEventListener('mouseout', e => {
    const li = e.target.closest('li.gm-has-submenu');
    if (!li) return;
    document.body.classList.remove('body-overlay');
  });
}







